/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DiscoverOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Discover Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 4c7.732 0 14 6.268 14 14s-6.268 14-14 14S4 25.732 4 18c.009-7.728 6.272-13.991 14-14Zm0-2.2C9.053 1.8 1.8 9.053 1.8 18S9.053 34.2 18 34.2 34.2 26.947 34.2 18 26.947 1.8 18 1.8Z"
    />
    <path
      d="M21.802 14.645a.817.817 0 0 0-.546-.531l-9.669-2.872a.408.408 0 0 0-.505.52l3.096 9.39a.819.819 0 0 0 .527.523l9.703 3.117a.41.41 0 0 0 .514-.516l-3.12-9.63Zm-6.286 5.037 4.308-4.205a.263.263 0 0 1 .434.108l2.179 6.726-6.817-2.19a.263.263 0 0 1-.104-.44Z"
    />
  </svg>`;
};
